var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"SectionTitleContainer"},[_c('div',{staticClass:"columns is-multiline"},[_c('div',{staticClass:"column is-12 has-text-centered mt-6"},[_c('h5',{staticClass:"is-size-1-tablet is-size-3-mobile",class:[{
        'has-text-white' : _vm.light,
        'has-text-black' : _vm.dark&&!_vm.light,
        'has-text-weight-bold' : _vm.bold,
      }]},[_vm._v(_vm._s(_vm.title))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }